<template>
  <v-card>
    <v-card-title class="headline">
      {{ $t("help.title") }}
    </v-card-title>
    <v-card-text>
      <p v-for="paragraph in $t('help.intro')" :key="paragraph">
        {{ paragraph }}
      </p>
      <h2>{{ $t("help.subtitle") }}</h2>
      <p
        v-for="paragraph in $t('help.feedback')"
        :key="paragraph"
        v-html="paragraph"
      ></p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
/** @define AgTermsAndConditions; weak */
</style>
